<template>
  <h3
    v-if="
      displayTextOnEmpty && widgets.length == 0 && globalWidgets.length == 0
    "
  >
    {{ $t("templateDashboard.noWidgets") }}
  </h3>
  <div v-else-if="loading">
    <v-progress-circular
      :size="50"
      :width="5"
      indeterminate
      color="primary"
      style="margin: auto"
    />
  </div>
  <div v-else>
    <global-widgets
      style="overflow: hidden"
      :value="globalWidgets"
      :tags="tags"
      :hide-buttons="notForm"
      @input="(val) => updateGlobalWidget(val)"
      @open-color-form="openColorDialog(item)"
      @open-image-map-editor="openImageMapEditor(item)"
      @select-widget="(w) => $emit('select-widget', w)"
    />
    <grid-layout
      style="
        width: 100% !important;
        min-height: 100% !important;
        overflow-x: hidden;
        overflow-y: scroll;
        margin-bottom: 5rem;
      "
      ref="widgetLayout"
      :layout.sync="layout"
      :cols="{ lg: 24, md: 24, sm: 24, xs: 24, xxs: 1 }"
      :col-num="24"
      :col-width="1"
      :key="gridKey"
      :row-height="rowHeight"
      :is-draggable="!notForm"
      :is-resizeable="!notForm"
      :responsive="true"
    >
      <grid-item
        v-for="(item, i) in layout"
        :key="i"
        :x.sync="item.x"
        :y.sync="item.y"
        :w.sync="item.w"
        :h.sync="item.h"
        :i.sync="item.i"
        :static="notForm"
        :resizeable="true"
        class="elevation-6"
      >
        <widget
          style="overflow: hidden"
          :value="item"
          :tags="tags"
          :hide-buttons="notForm"
          @input="(val) => updateWidget(i, val)"
          @open-color-form="openColorDialog(item)"
          @open-image-map-editor="openImageMapEditor(item)"
          @select-widget="(w) => $emit('select-widget', w)"
        />
      </grid-item>

      <widget-image-map-editor
        v-model="selectedItem"
        :state="imageMapDialog"
        v-on:state-update="(v) => (imageMapDialog = v)"
      />

      <v-dialog v-model="colorDialog" persistent max-width="600">
        <v-card style="overflow-y: scroll">
          <v-card-title>{{ $t("module.colorFormTitle") }}</v-card-title>
          <colors-form
            v-if="selectedItem !== undefined"
            v-model="selectedItem"
          />
          <v-card-actions>
            <v-btn
              text
              small
              color="gray"
              type="submit"
              @click="closeDialog"
              x-large
              >{{ $t("common.close") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </grid-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Widget from "./widgets/Widget.vue";
import VueGridLayout from "vue-grid-layout";
import ColorsForm from "./customForm/ColorsForm.vue";
import WidgetImageMapEditor from "./widgets/ImageMap/WidgetImageMapEditor.vue";
import widgetMixin from "../../_helpers/widgetMixin";
import GlobalWidgets from "./widgets/GlobalWidgets.vue";

export default {
  components: {
    Widget,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    ColorsForm,
    WidgetImageMapEditor,
    GlobalWidgets,
  },

  mixins: [widgetMixin],

  props: {
    tags: {
      type: Array,
      default: () => [],
    },

    notForm: {
      type: Boolean,
      default: false,
    },

    displayTextOnEmpty: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      rowHeight: 30,
      gridKey: 1,
      colorDialog: false,
      imageMapDialog: false,
      selectedItem: undefined,
      loading: false,
    };
  },

  computed: {
    ...mapState("templateDashboard", {
      storeWidgets: "widgets",
      storeGlobalWidgets: "globalWidgets",
    }),
    ...mapState("tag", ["tagsWithMeta"]),

    widgets: {
      get() {
        return this.storeWidgets;
      },

      set(val) {
        this.setWidgets(val);
      },
    },

    globalWidgets: {
      get() {
        return this.storeGlobalWidgets;
      },

      set(val) {
        this.setGlobalWidgets(val);
      },
    },

    layout: {
      get() {
        return this.widgets;
      },

      set(val) {
        if (this.notForm)
          for (var v of val) {
            var widget = this.widgets.find(
              (x) => x.templateWidgetId == v.templateWidgetId,
            );
            if (widget) {
              widget.x = v.x;
              widget.y = v.y;
              widget.w = v.w;
              widget.h = v.h;
            }
          }
      },
    },
  },

  methods: {
    ...mapActions("templateDashboard", ["setWidgets", "setGlobalWidgets"]),
    ...mapActions("tag", ["getTagWithMetaAndKeys"]),

    refresh() {
      this.gridKey += 1;
    },

    updateWidget(index, widget) {
      this.storeWidgets[index] = widget;
    },

    updateGlobalWidget(widgets) {
      this.storeGlobalWidgets = widgets;
    },

    openColorDialog(widget) {
      this.selectedItem = widget;
      this.colorDialog = true;
    },

    openImageMapEditor(widget) {
      this.selectedItem = widget;
      this.imageMapDialog = true;
    },

    closeDialog() {
      this.gridKey += 1;
      this.selectedItem = undefined;
      this.colorDialog = false;
    },
  },

  async created() {
    if (!this.shouldFake) {
      this.loading = true;
      await this.getTagWithMetaAndKeys(
        this.getDeveuiAndKeysForSlotsFromAllWidgets(this.tags),
      );
    }
    this.loading = false;
  },

  watch: {
    tags: {
      async handler(newVal, oldVal) {
        if (!this.shouldFake && oldVal != newVal && newVal.length > 0) {
          this.loading = true;
          await this.getTagWithMetaAndKeys(
            this.getDeveuiAndKeysForSlotsFromAllWidgets(newVal),
          );
        }
        this.loading = false;
      },
    },
  },
};
</script>
